
import urlConstantJs from '../../../config/ConstantConfig'

export const getLink = (href) => {
  let targetLink =  href;
  if(href) {
    if(href.includes("http")){
      targetLink = href;
    }else {
      targetLink= urlConstantJs.navURL + href 
    }
  }
  return targetLink
}